import {
  SET_SEARCH_CLAIM,
  UPDATE_SEARCH_CLAIM,
  UPDATE_SEARCH_CLAIM_CRITERIA,
  SET_SEARCH_CLAIM_CRITERIA,
} from "./actionType";
let initCriteria = {
  ClaimNo: "",
  Mill: "",
  Status: "",
  PIC: "",
};
let init = {
  searchData: [],
  criteria: initCriteria,
};

export default function reducer(state = init, action) {
  return {
    searchData: searchData(state.searchData, action),
    criteria: criteria(state.criteria, action),
  };
}

function criteria(state = initCriteria, action) {
  switch (action.type) {
    case UPDATE_SEARCH_CLAIM_CRITERIA: {
      return {
        ...state,
        [action.name]: action.payload,
      };
    }
    case SET_SEARCH_CLAIM_CRITERIA: {
      return {
        ...action.payload,
      };
    }
    default:
      return state;
  }
}

function searchData(state = [], action) {
  switch (action.type) {
    case SET_SEARCH_CLAIM: {
      return [...action.payload];
    }
    case UPDATE_SEARCH_CLAIM: {
      let newArry = state.slice();
      newArry[action.index] = { ...action.payload };
      return newArry;
    }
    default:
      return state;
  }
}
